import type { SearchResultDto } from '@bqcrm/shared';
import { Select } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { api } from '../api';

/** Wybór kontrahenta z wyszukiwaniem w bazie (telefon, nazwisko, nazwa). */
export function PartyPicker({
  label,
  value,
  initialLabel,
  onChange,
  placeholder = 'Wpisz nazwisko, nazwę lub telefon…',
}: {
  label: string;
  value: string | null;
  initialLabel?: string | null;
  onChange: (id: string | null) => void;
  placeholder?: string;
}) {
  const [search, setSearch] = useState('');
  const [debounced] = useDebouncedValue(search, 300);
  const q = useQuery({
    queryKey: ['party-picker', debounced],
    queryFn: () => api<SearchResultDto>(`/search?q=${encodeURIComponent(debounced)}`),
    enabled: debounced.trim().length >= 2,
  });
  const options = (q.data?.parties ?? []).map((p) => ({ value: p.id, label: `${p.displayName}${p.city ? ` (${p.city})` : ''}` }));
  if (value && initialLabel && !options.some((o) => o.value === value)) options.unshift({ value, label: initialLabel });

  return (
    <Select
      label={label}
      placeholder={placeholder}
      searchable
      clearable
      data={options}
      value={value}
      onChange={onChange}
      onSearchChange={setSearch}
      searchValue={search}
      nothingFoundMessage={debounced.length >= 2 ? 'Nie znaleziono' : 'Wpisz co najmniej 2 znaki'}
      filter={({ options: o }) => o}
    />
  );
}
